import React from 'react';
import closeIcon from '../../images/close-blue.png';
import Portal from './Portal';
import CustomButton from './buttons';
import { Colors } from '../../themes/colors';

export const NewCustomPopup = ({
  title,
  rightButtonText,
  leftButtonText,
  rightButtonPressed,
  leftButtonPressed,
  children,
  rightButtonDisabled = false,
  containerStyle = {},
  leftButtonProps = {},
  rightButtonProps = {},
  onCloseIconClick,
}) => (
  <Portal>
    <div className="modal" onMouseDownCapture={(e) => e.stopPropagation()}>
      <div
        className="modal_content"
        style={{ minHeight: 0, padding: 20, margin: 25, position: 'relative', ...containerStyle }}
      >
        {onCloseIconClick && (
          <div
            style={{
              position: 'absolute',
              right: 32,
              cursor: 'pointer',
            }}
            onClick={onCloseIconClick}
          >
            <img src={closeIcon} alt="close_icon" />
          </div>
        )}
        <span
          style={{
            fontFamily: 'Nunito Sans',
            fontWeight: 400,
            fontSize: 24,
            textAlign: 'center',
            verticalAlign: 'middle',
            color: '#494963',
            marginTop: 40,
          }}
        >
          {title || ''}
        </span>

        {children}

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 20,
            marginTop: 20,
            marginBottom: 40,
          }}
        >
          {leftButtonPressed && (
            <CustomButton
              name={leftButtonText}
              click={leftButtonPressed}
              style={{
                minWidth: 150,
                height: 34,
                borderRadius: 4,
                backgroundColor: Colors.neutral_500,
              }}
              fontSize={14}
              {...leftButtonProps}
            />
          )}
          {rightButtonPressed && (
            <CustomButton
              name={rightButtonText}
              btnDisabled={rightButtonDisabled}
              click={rightButtonPressed}
              style={{
                minWidth: 150,
                height: 34,
                borderRadius: 4,
                backgroundColor: rightButtonDisabled ? Colors.neutral_200 : Colors.secondary_500,
              }}
              fontSize={14}
              {...rightButtonProps}
            />
          )}
        </div>
      </div>
    </div>
  </Portal>
);
